"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.backofficeDevices_de_de = void 0;
function backofficeDevices_de_de() {
    return {
        "backoffice.devices.title": "Geräte",
        "backoffice.devices.subtitle": "Koppeln Sie Ihre Geräte und steuern Sie den angezeigten Inhalt.",
        "backoffice.devices.add": "Gerät hinzufügen",
        "backoffice.devices.name": "Name",
        "backoffice.devices.paired": "Pairing",
        "backoffice.devices.currentcontent": "Aktueller Inhalt",
        "backoffice.devices.lastcontact": "Letzter Kontakt",
        "backoffice.devices.nocontact": "Niemals",
        "backoffice.devices.configure.title": "Gerät \"${deviceName}\" konfigurieren",
        "backoffice.devices.configure.webview": "WebView Link",
        "backoffice.devices.configure.fullscreen": "Vollbild",
        "backoffice.devices.configure.selectdata.title": "Inhaltstyp auswählen",
        "backoffice.devices.configure.selectdata.application.title": "Applikation",
        "backoffice.devices.configure.selectdata.application.description": "Senden Sie eine Applikation an Ihr Gerät",
        "backoffice.devices.configure.selectdata.application.secondtitle": "Wählen Sie die Applikation aus, die Sie an Ihr Gerät senden möchten",
        "backoffice.devices.configure.selectdata.checkin.title": "Check-In App",
        "backoffice.devices.configure.selectdata.checkin.description": "Senden Sie eine Check-In App an Ihr Gerät",
        "backoffice.devices.configure.selectdata.checkin.secondtitle": "Wählen Sie die Check-In App aus, die Sie an Ihr Gerät senden möchten",
        "backoffice.devices.configure.selectdata.checkin.warning": "Weitere Updates werden diese Check-In App nicht auf Ihrem Gerät überschreiben, da Kunden diese womöglich gerade verwenden. Falls Sie die Konfiguration Ihres Gerätes anpassen wollen, speichern Sie diese und drücken danach den 'Neu Laden' Button in der Applications App auf Ihrem Gerät.",
        "backoffice.devices.configure.selectdata.checkin.printer": "Drucker Konfiguration",
        "backoffice.devices.configure.selectdata.website.title": "Webseite",
        "backoffice.devices.configure.selectdata.website.description": "Senden Sie eine beliebige Webseite an Ihr Gerät",
        "backoffice.devices.configure.selectdata.website.secondtitle": "Geben Sie hier die URL der Webseite ein, die Sie zu Ihrem Gerät senden möchten",
        "backoffice.devices.configure.sendbtn": "An Gerät senden",
        "backoffice.devices.code.title": "Code",
        "backoffice.devices.code.description": "Verwenden Sie den Code, der auf Ihrem Gerät erscheint",
        "backoffice.devices.empty.title": "Keine Geräte gefunden...",
        "backoffice.devices.empty.meanwhile": "Hier können Sie Geräte hinzufügen und via Firebase Cloud Messaging verbinden. Probieren Sie es doch gleich aus!",
        "backoffice.devices.empty.adddevice": "Ihr erstes Gerät hinzufügen",
        "backoffice.devices.editor.title": "Gerät verbinden"
    };
}
exports.backofficeDevices_de_de = backofficeDevices_de_de;
